import Button from "components/common/buttons/buttons";
import { useKBGlobalState } from "contexts/KBContext";
import { useRouter } from "next/router";
import { CRYPTO } from "utils/constant/ITME_INFO";
import { useRef, useState } from "react";
import DetailTradeCTA from "../../KB/TradeCTA";
import useModalClickOutside from "utils/useModalClickOutside";

function DetailHeaderKBOrder({
  isLoginUser,
  isMobile,
  detailData,
}: {
  isLoginUser: boolean;
  isMobile: boolean;
  detailData: any;
}) {
  const router = useRouter();
  const [orderDropdownVisible, setOrderDropdownVisible] = useState(false);
  const dropdownRef = useModalClickOutside(setOrderDropdownVisible);
  const { accounts, isAccountLoading } = useKBGlobalState();
  const isNotLoginUserOrNoAccount =
    !isLoginUser || (!accounts?.length && !isAccountLoading);

  if (
    isMobile &&
    router.locale === "ko" &&
    detailData?.CAT !== "Index" &&
    detailData?.CAT !== CRYPTO
  ) {
    return (
      <div className="relative p-[6px]">
        <Button
          type="primary"
          size="sm"
          text="주문"
          clickHandler={() => {
            console.log("accounts?.length", accounts?.length);
            if (!isLoginUser) router.push(`/login?from${router.asPath}`);
            else if (isAccountLoading) return;
            else if (!accounts?.length) router.push("/kb/welcome");
            else setOrderDropdownVisible(true);
          }}
          btnClass="!bg-black !text-white"
          data-gtm-id="sDetail-kb-order-button"
        />
        {orderDropdownVisible && (
          <div
            ref={dropdownRef}
            className="absolute top-[calc(100%+18px)] right-0 w-full bg-white p-3 flex flex-col gap-2 rounded-[12px] z-[1]"
            style={{
              boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.16)",
              width: "130px",
            }}
          >
            <DetailTradeCTA
              isMobile={isMobile}
              isLoginUser={isLoginUser}
              orderCategory={detailData?.ORDER_CATEGORY}
            />
          </div>
        )}
      </div>
    );
  }
  return null;
}

export default DetailHeaderKBOrder;
